import { Modal, Table, Typography, Tooltip } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const { Title } = Typography;

function PlayerModal({ player, visible, onClose, playerGameHistory }) {
  if (!player) return null;

  const columns = [
    {
      title: 'Round #',
      dataIndex: 'round',
      key: 'round',
      width: 70,
      align: 'center',
    },
    {
      title: 'Player',
      dataIndex: 'playerName',
      key: 'playerName',
      width: 150,
    },
    {
      title: 'Army',
      dataIndex: 'playerArmy',
      key: 'playerArmy',
      width: 150,
      render: (text, record) => {
        if (!text) {
          return <i style={{ color: '#999' }}>Missing from BCP</i>;
        }
        return (
          <Tooltip title="Open army list in BCP">
            <a
              target="_blank"
              href={`https://bestcoastpairings.com/list/${record.playerArmyListId}`}
              rel="noreferrer"
            >
              {text}
            </a>
          </Tooltip>
        );
      },
    },
    {
      title: 'Score',
      key: 'score',
      width: 80,
      align: 'center',
      render: (_, record) => `${record.playerScore ?? '?'}-${record.opponentScore ?? '?'}`,
    },
    {
      title: 'Opponent Army',
      dataIndex: 'opponentArmy',
      key: 'opponentArmy',
      width: 150,
      render: (text, record) => {
        if (!text) {
          return <i style={{ color: '#999' }}>Missing from BCP</i>;
        }
        return (
          <Tooltip title="Open army list in BCP">
            <a
              target="_blank"
              href={`https://bestcoastpairings.com/list/${record.opponentArmyListId}`}
              rel="noreferrer"
            >
              {text}
            </a>
          </Tooltip>
        );
      },
    },
    {
      title: 'Opponent Name',
      key: 'opponentName',
      width: 150,
      render: (_, record) => record.opponentName,
    },
    {
      title: 'Team',
      dataIndex: 'opponentTeam',
      key: 'opponentTeam',
      width: 120,
    },
    {
      title: 'Mission',
      key: 'mission',
      width: 200,
      render: (_, record) => record.mission || '-',
    },
  ];

  return (
    <Modal
      title={
        <Title level={4} style={{ margin: 0 }}>
          {player.firstName} {player.lastName} - Game History
        </Title>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width={1200}
      centered
      closeIcon={<CloseOutlined />}
      maskStyle={{
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(4px)',
      }}
    >
      <Table
        columns={columns}
        dataSource={playerGameHistory}
        rowKey={(record) => `${record.round}-${record.playerId}`}
        size="small"
        pagination={false}
        scroll={{ x: 1100 }}
      />
    </Modal>
  );
}

export default PlayerModal;